import axiosInstance from "./http/axios_instance"
const http = axiosInstance("/protected",  null, "/forbidden")

const searchAddress = (value) => http.get("/property_search/" + value.trim());

export default {
    searchAddress
}